import { render } from "./TheMainApps.vue?vue&type=template&id=6df6c77f&scoped=true"
import script from "./TheMainApps.vue?vue&type=script&lang=js"
export * from "./TheMainApps.vue?vue&type=script&lang=js"

import "./TheMainApps.vue?vue&type=style&index=0&id=6df6c77f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df6c77f"]])

export default __exports__